import { TypedTable } from "@/components/ui/table/TypedTable";
import { createColumnHelper, tableFeatures } from "@tanstack/react-table";
import { useMemo } from "react";
import type { LineaPedido } from "./ModalInfoPedido";
import { CommonFeatures } from "@/hooks/useTanstackTable";

interface TablaInfoPedidoProps {
	readonly data: LineaPedido[];
	readonly isPending: boolean;
	readonly errMessage: string | null;
}
export function TablaInfoPedido(props: TablaInfoPedidoProps) {
	const { columns, features } = useMemo(() => Columns(), []);


	return (
		<TypedTable
			columns={columns}
			features={features}
			data={props.data}
			className="dataTable display"

			noResultsMessage="No se encontraron pedidos"
			errorMessage="Error al cargar la información del pedido"
			isLoading={props.isPending}
			isError={props.errMessage != null}
		/>
	);
}


function Columns() {
	const columnHelper = createColumnHelper<typeof features, LineaPedido>();
	const features = tableFeatures(CommonFeatures);

	const idAccesor = (data: LineaPedido) => {
		if (data.idArticulo == null) return data.descripcion ?? "-";
		if (data.descripcion == null) return data.idArticulo;
		return `${data.idArticulo}-${data.descripcion}`;
	};

	const columns = columnHelper.columns([
		columnHelper.accessor("idLinea", { header: "Linea" }),
		columnHelper.accessor(idAccesor, { id: "Articulo", header: "Articulo" }),
		columnHelper.accessor("cantidad", { header: "Cantidad ped", cell: info => info.getValue() ?? "-" }),
		columnHelper.accessor("cantidadEmpaquetada", { header: "Cantidad emp", cell: info => info.getValue() ?? "-" }),

	]);
	return { columns, features };
}